import styled from '../../../../styles/theme';
import { ModalTiresDetailStyled } from '../ModalTiresDetailStyled';
import { rem } from 'polished';

export const ModalTiresDetailStyledAC = styled(ModalTiresDetailStyled)`    
    a {
        color: ${({ theme }) => theme.colors.red} !important;
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-decoration: none;
        font-size: ${({ theme }) => theme.fontSizes.h4};
        
        &:hover {
            color: ${({ theme }) => theme.colors.grey5} !important;
            
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.grey5};
                }
            }
        }
        
        svg {
            width: ${rem(20)};
            height: ${rem(12)};
            
            path {
                fill: ${({ theme }) => theme.colors.red};
            }
        }
    }
`;
